import React, { Component, Suspense } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import { DashboardBody, GlobalStyle, Sidebar } from "./style";
import ResponsiveFix from "../../components/responsiveFix";
import Header from "../components/header";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import { Confirm } from "../../components/confirm";
import { FullScreenLoading } from "../../components/loading";
import { Add } from "./components/add/add";
import {
  ACCOUNT_REVIEW_MANAGER,
  ACCOUNT_REVIEW_PETTY_CASHIER,
  CONTACTS_ACTIVITY_REVIEW_MANAGER,
  CONTACTS_ACTIVITY_REVIEW_PETTY_CASHIER,
  CONTACTS_BASE_ACTIVITY_REVIEW_PETTY_CASHIER,
  CONTACTS_BASE_ACTIVITY_REVIEW_MANAGER,
  COST_CLASSIFICATION_MANAGER,
  COST_CLASSIFICATION_PETTY_CASHIER,
  CREATE_DATA_MANAGER,
  CREATE_DATA_PETTY_CASHIER,
  DASHBOARD_MANAGER,
  DASHBOARD_PETTY_CASHIER,
  FILES,
  HASHTAGS_SELECT_REPORT_PETTY_CASHIER,
  MONTHLY_SELECT_REPORT_PETTY_CASHIER,
  PETTY_CASH_BUDGET_REPORT_MANAGER,
  PETTY_CASH_REPORTS_MANAGER,
  PETTY_CASH_REPORTS_PETTY_CASHIER,
  HASHTAGS_SELECT_REPORT_MANAGER
} from "../../constants/urls";
import { NON_CUSTODIAN_PANEL } from "../../constants/panelTypes";
import { INIT_REQUEST } from "../../actions/actionTypes";
import { WARNING_SINGLE_BUTTON_TEXT } from "../../constants/otherTexts";
import { getPanel } from "../../assets/selectProjectUserOrPanel";
import { checkAccessesForManagerPanel } from "../../assets/checkAccess";
import { changePanel, getTargetPanelData } from "../../assets/changePanel";
import LinkItem from "./components/linkItem";
import BudgetIcon from "../../projectSpecificComponents/svgIcons/budget/report";
import MonthlyReportIcon from "../../projectSpecificComponents/svgIcons/monthlyReport";
import HashtagIcon from "../../projectSpecificComponents/svgIcons/hashtag";
import { renderPremiumText } from "../../assets/renderPremiumIconWithText";
import {
  checkPermissionHandleClick,
  checkPremiumFeature
} from "../../assets/checkPremium";
import {
  ADD_PETTY_CASH_BUDGET,
  CONTACT_REPORT
} from "../../constants/premiumActions";
import {
  ACCOUNT_REVIEW_ICON,
  ARCHIVE_FILES_ICON,
  CONTACT_ICON,
  COST_CLASSIFICATION_ICON,
  HOME_ICON,
  IMPREST_ICON
} from "../../constants/icons";
import { setMenuColors } from "../../assets/setTheme";
import { preventRouteRepeatOnPush } from "../../lib/preventRouteRepeat";

class Index extends Component {
  constructor(props) {
    super(props);
    let sidebarExpand = window.innerWidth > 1199;
    if (localStorage.getItem("expand") !== null) {
      sidebarExpand = localStorage.getItem("expand") === "true";
    }
    this.state = {
      hasShadow: false,
      sidebarExpand: sidebarExpand,
      userClickTrigger: false,
      showConfirm: false
    };
    this.onScroll = this.onScroll.bind(this);
    this.sidebarToggleHandler = this.sidebarToggleHandler.bind(this);
    this.windowResizeHandler = this.windowResizeHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.windowResizeHandler);
    sessionStorage.removeItem("activityEmployeeContact");
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.windowResizeHandler);
  }

  onScroll(event) {
    if (event.target.scrollTop >= 10) {
      this.setState({ hasShadow: true });
    } else {
      this.setState({ hasShadow: false });
    }
  }

  windowResizeHandler() {
    this.setState({ sidebarExpand: window.innerWidth > 1199 });
    localStorage.setItem("expand", window.innerWidth > 1199);
  }

  sidebarToggleHandler() {
    if (!this.state.userClickTrigger) {
      window.removeEventListener("resize", this.windowResizeHandler);
    }
    this.setState({
      sidebarExpand: !this.state.sidebarExpand,
      userClickTrigger: true
    });
    localStorage.setItem("expand", !this.state.sidebarExpand);
  }

  checkIsManagerDashboardOrPettyCashier() {
    const panel = getPanel();
    let isManager;
    let accountReviewRoute;
    let pettyCashReportsRoute;
    let costClassificationRoute;
    let budgetReportRoute;
    let contactRoute;
    let baseContactRoute;
    let createDataRoute;
    let homeRoute;
    let monthlyReportsRoute;
    let hashtagsReportsRoute;
    if (panel === NON_CUSTODIAN_PANEL) {
      isManager = true;
      accountReviewRoute = ACCOUNT_REVIEW_MANAGER;
      pettyCashReportsRoute = PETTY_CASH_REPORTS_MANAGER;
      costClassificationRoute = COST_CLASSIFICATION_MANAGER;
      budgetReportRoute = PETTY_CASH_BUDGET_REPORT_MANAGER;
      createDataRoute = CREATE_DATA_MANAGER;
      baseContactRoute = CONTACTS_BASE_ACTIVITY_REVIEW_MANAGER;
      contactRoute = CONTACTS_ACTIVITY_REVIEW_MANAGER;
      homeRoute = DASHBOARD_MANAGER;
      hashtagsReportsRoute = HASHTAGS_SELECT_REPORT_MANAGER;
    } else {
      isManager = false;
      accountReviewRoute = ACCOUNT_REVIEW_PETTY_CASHIER;
      pettyCashReportsRoute = PETTY_CASH_REPORTS_PETTY_CASHIER;
      costClassificationRoute = COST_CLASSIFICATION_PETTY_CASHIER;
      baseContactRoute = CONTACTS_BASE_ACTIVITY_REVIEW_PETTY_CASHIER;
      contactRoute = CONTACTS_ACTIVITY_REVIEW_PETTY_CASHIER;
      createDataRoute = CREATE_DATA_PETTY_CASHIER;
      homeRoute = DASHBOARD_PETTY_CASHIER;
      monthlyReportsRoute = MONTHLY_SELECT_REPORT_PETTY_CASHIER;
      hashtagsReportsRoute = HASHTAGS_SELECT_REPORT_PETTY_CASHIER;
    }

    return {
      isManager,
      createDataRoute,
      homeRoute,
      budgetReportRoute,
      baseContactRoute,
      contactRoute,
      accountReviewRoute,
      pettyCashReportsRoute,
      costClassificationRoute,
      monthlyReportsRoute,
      hashtagsReportsRoute
    };
  }

  render() {
    const { Component, route, initData, history } = this.props;
    const { hasShadow, sidebarExpand, showConfirm } = this.state;
    const {
      isManager,
      createDataRoute,
      homeRoute,
      budgetReportRoute,
      baseContactRoute,
      contactRoute,
      accountReviewRoute,
      pettyCashReportsRoute,
      costClassificationRoute,
      monthlyReportsRoute,
      hashtagsReportsRoute
    } = this.checkIsManagerDashboardOrPettyCashier();

    console.log(history.location.pathname);
    console.log(pettyCashReportsRoute);
    console.log(history.location.pathname.startsWith(pettyCashReportsRoute));
    console.log(history.location.pathname.startsWith(pettyCashReportsRoute));
    return (
      <ResponsiveFix>
        <Confirm
          show={showConfirm}
          rejectHandler={() => this.setState({ showConfirm: false })}
          close={() => this.setState({ showConfirm: false })}
          content={{
            type: "info",
            title: "توجه!",
            message: "این امکان در ورژن بعدی تنخواه‌گردان ارائه خواهد شد.",
            rejectButtonText: WARNING_SINGLE_BUTTON_TEXT,
            icon: "icon mapsa-info"
          }}
        />
        <GlobalStyle />
        <Header
          sidebarToggleHandler={this.sidebarToggleHandler}
          data={initData}
          isManager={isManager}
        >
          <Add
            hasShadow={hasShadow}
            expand={sidebarExpand}
            route={createDataRoute}
          />
        </Header>
        <Sidebar expand={sidebarExpand} onScroll={this.onScroll}>
          <ul className="sidebar-list">
            <LinkItem
              onClick={() => preventRouteRepeatOnPush(homeRoute, history)}
              className={
                history.location.pathname === homeRoute
                  ? "list-item-active"
                  : ""
              }
              title="خانه"
              icon={HOME_ICON}
              color={setMenuColors(isManager).color}
              backgroundColor={setMenuColors(isManager).backgroundColor}
              expand={sidebarExpand}
            />
            {isManager && (
              <LinkItem
                onClick={() =>
                  preventRouteRepeatOnPush(pettyCashReportsRoute, history)
                }
                className={
                  history.location.pathname.startsWith(pettyCashReportsRoute)
                    ? "list-item-active"
                    : ""
                }
                activeClassName="list-item-active"
                title="گزارش‌های تنخواه"
                icon={IMPREST_ICON}
                color={setMenuColors(isManager).color}
                backgroundColor={setMenuColors(isManager).backgroundColor}
                expand={sidebarExpand}
              />
            )}
            <LinkItem
              onClick={() =>
                preventRouteRepeatOnPush(accountReviewRoute, history)
              }
              className={
                history.location.pathname === accountReviewRoute
                  ? "list-item-active"
                  : ""
              }
              activeClassName="list-item-active"
              title="مرور حساب‌ها"
              icon={ACCOUNT_REVIEW_ICON}
              color={setMenuColors(isManager).color}
              backgroundColor={setMenuColors(isManager).backgroundColor}
              expand={sidebarExpand}
            />
            <LinkItem
              onClick={() =>
                preventRouteRepeatOnPush(costClassificationRoute, history)
              }
              className={
                history.location.pathname.startsWith(costClassificationRoute)
                  ? "list-item-active"
                  : ""
              }
              activeClassName="list-item-active"
              title="طبقه‌بندی مخارج"
              icon={COST_CLASSIFICATION_ICON}
              color={setMenuColors(isManager).color}
              backgroundColor={setMenuColors(isManager).backgroundColor}
              expand={sidebarExpand}
            />

            {!isManager && (
              <LinkItem
                onClick={() =>
                  preventRouteRepeatOnPush(pettyCashReportsRoute, history)
                }
                className={
                  history.location.pathname === pettyCashReportsRoute
                    ? "list-item-active"
                    : ""
                }
                activeClassName="list-item-active"
                title="گزارش‌های تنخواه"
                icon={IMPREST_ICON}
                color={setMenuColors(isManager).color}
                backgroundColor={setMenuColors(isManager).backgroundColor}
                expand={sidebarExpand}
              />
            )}
            <LinkItem
              onClick={() => {
                checkPermissionHandleClick(
                  () => preventRouteRepeatOnPush(contactRoute, history),
                  CONTACT_REPORT
                );
              }}
              className={
                history.location.pathname.startsWith(baseContactRoute)
                  ? "list-item-active"
                  : ""
              }
              activeClassName="list-item-active"
              title={renderPremiumText("گزارش طرف حساب‌ها", showMessage =>
                checkPremiumFeature(CONTACT_REPORT, showMessage)
              )}
              icon={CONTACT_ICON}
              color={setMenuColors(isManager).color}
              backgroundColor={setMenuColors(isManager).backgroundColor}
              expand={sidebarExpand}
            />
            {!isManager && (
              <LinkItem
                onClick={() =>
                  preventRouteRepeatOnPush(monthlyReportsRoute, history)
                }
                className={
                  history.location.pathname.startsWith(monthlyReportsRoute)
                    ? "list-item-active"
                    : ""
                }
                activeClassName="list-item-active"
                title={"گزارش‌ ماهانه"}
                SvgIcon={MonthlyReportIcon}
                color={setMenuColors(isManager).color}
                backgroundColor={setMenuColors(isManager).backgroundColor}
                expand={sidebarExpand}
              />
            )}
            <LinkItem
              onClick={() =>
                preventRouteRepeatOnPush(hashtagsReportsRoute, history)
              }
              className={
                history.location.pathname.startsWith(hashtagsReportsRoute)
                  ? "list-item-active"
                  : ""
              }
              activeClassName="list-item-active"
              title="گزارش‌ هشتگ‌ها"
              SvgIcon={HashtagIcon}
              color={setMenuColors(isManager).color}
              backgroundColor={setMenuColors(isManager).backgroundColor}
              expand={sidebarExpand}
            />
            {isManager && (
              <LinkItem
                onClick={() =>
                  preventRouteRepeatOnPush(budgetReportRoute, history)
                }
                className={
                  history.location.pathname === budgetReportRoute
                    ? "list-item-active"
                    : ""
                }
                activeClassName="list-item-active"
                title="گزارش‌های بودجه تنخواه"
                SvgIcon={BudgetIcon}
                color={setMenuColors(isManager).color}
                backgroundColor={setMenuColors(isManager).backgroundColor}
                expand={sidebarExpand}
              />
            )}
            <LinkItem
              onClick={() => preventRouteRepeatOnPush(FILES, history)}
              className={
                history.location.pathname === FILES ? "list-item-active" : ""
              }
              activeClassName="list-item-active"
              title="آرشیو فایل‌های دریافتی"
              icon={ARCHIVE_FILES_ICON}
              color={setMenuColors(isManager).color}
              backgroundColor={setMenuColors(isManager).backgroundColor}
              expand={sidebarExpand}
            />
          </ul>
          <div className="sidebar-footer">
            <div>
              {checkAccessesForManagerPanel(getTargetPanelData().accesses) && (
                <React.Fragment>
                  <div
                    className="panel-link"
                    title={getTargetPanelData().title}
                    onClick={() => changePanel()}
                  >
                    {getTargetPanelData().title}
                  </div>{" "}
                  {/*<span className="circle-separator" />*/}
                </React.Fragment>
              )}
              <NavLink
                title="راهنمای تنخواه‌گردان"
                to="//tankhahgardan.com/help"
                target="_blank"
              >
                راهنما
              </NavLink>{" "}
              <span className="circle-separator" />
              <NavLink
                title=" قوانین و مقررات"
                to="//tankhahgardan.com/terms/"
                target="_blank"
              >
                قوانین و مقررات
              </NavLink>
            </div>
            <div className="copyright">
              حقوق این وبسایت متعلق به شرکت دانش آتیه معماری و ساخت می‌باشد.
            </div>
            <div className="minimum-mode-icon">
              <NavLink
                to="//tankhahgardan.com/help"
                target="_blank"
                title="راهنمای تنخواه‌گردان"
              >
                <i className="icon mapsa-i-letter" />
              </NavLink>
            </div>
          </div>
        </Sidebar>
        <DashboardBody expand={sidebarExpand}>
          <div className="dashboard-container">
            <Suspense fallback={<FullScreenLoading />}>
              <Component route={route} expand={sidebarExpand} />
            </Suspense>
          </div>
        </DashboardBody>
      </ResponsiveFix>
    );
  }
}

const mapStateToProps = store => {
  return {
    initData: store.Init.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    requestInit: () => {
      dispatch({ type: INIT_REQUEST });
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Index)
);
